function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { VNode } from 'snabbdom';
import { AttrsSchema, Component, jsx } from 'panel';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { SvgIconEl } from 'common/components/svg-icon';
import { TooltipEl } from 'common/components/tooltip';
import css from './index.inline.styl';
import './index.styl';
export const SegmentationLimitLearnMoreUrl = "https://docs.mixpanel.com/docs/analysis/advanced/other-advanced-features#limits-and-ordering";
export type SegmentationLimitInfoAttrsSchema = {
  'segmentation-limit': number;
  'export-segmentation-limit': number;
};
export interface LimitInfoJsxProps {
  attrs?: SegmentationLimitInfoAttrsSchema;
  on?: EmptyObj;
  props?: EmptyObj;
}

/*
 * Slightly opinionated icon and tooltip for reports that experience result truncation
 *  due to segmentation query limits.
 *
 */
export class SegmentationLimitInfo extends Component<EmptyObj, SegmentationLimitInfoAttrsSchema> {
  static get attrsSchema(): AttrsSchema<LimitInfoJsxProps[`attrs`]> {
    return _objectSpread(_objectSpread({}, super.attrsSchema), {}, {
      'segmentation-limit': {
        type: "number",
        description: "Required numeric value representing the query limit affecting this chart."
      },
      'export-segmentation-limit': {
        type: "number",
        description: "Required numeric value representing the query limit applied to exporting the data behind this chart."
      }
    });
  }
  get config() {
    return {
      css,
      useShadowDom: true,
      template: () => this.renderTemplate(),
      defaultState: {}
    };
  }
  private get segmentationLimit(): number {
    return this.attr("segmentation-limit");
  }
  private get exportSegmentationLimit(): number {
    return this.attr("export-segmentation-limit");
  }
  private renderTemplate(): VNode {
    return <div sel='.segmentation-limit-info'>
        <SvgIconEl attrs={{
        icon: "info"
      }} />
        <TooltipEl attrs={{
        'always-show': false,
        'max-width': "200px"
      }}>
          <p>
            We limit the number of segments to {this.segmentationLimit.toLocaleString()}.&nbsp;
            <a attrs={{
            href: SegmentationLimitLearnMoreUrl,
            target: "_blank"
          }}>Learn more</a>
            {this.tooltipExtraAction()}.
          </p>
        </TooltipEl>
      </div>;
  }
  private tooltipExtraAction() {
    return [" or ", <a attrs={{
      href: "javascript:void(0);"
    }} on={{
      click: () => this.dispatchEvent(new CustomEvent("export-csv", {
        bubbles: true,
        composed: true
      }))
    }}>
        export up to {this.exportSegmentationLimit.toLocaleString()} segments via CSV
      </a>];
  }
}
export const SegmentationLimitInfoEl = defineAndMakeJsxFactory("mp-segmentation-limit-info", SegmentationLimitInfo);
export const SegmentationLimitInfoReact = panel2react("mp-segmentation-limit-info", SegmentationLimitInfo);